import { render, staticRenderFns } from "./lunup.vue?vue&type=template&id=3b07961a&scoped=true"
import script from "./lunup.vue?vue&type=script&lang=js"
export * from "./lunup.vue?vue&type=script&lang=js"
import style0 from "./lunup.vue?vue&type=style&index=0&id=3b07961a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07961a",
  null
  
)

export default component.exports